import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkflowVertexLibraryComponent } from './workflow-vertex-library.component';
import { WorkflowVertexLibraryItemComponent } from './workflow-vertex-library-item.component';

const EXTERNAL_COMPONENTS = [
  WorkflowVertexLibraryComponent
];

const INTERNAL_COMPONENTS = [
  WorkflowVertexLibraryItemComponent
];

@NgModule({
  imports: [
    CommonModule,
  ],
  exports: EXTERNAL_COMPONENTS,
  declarations: [ ...EXTERNAL_COMPONENTS, ...INTERNAL_COMPONENTS ],
  entryComponents: [ WorkflowVertexLibraryComponent ]
})
export class WorkflowVertexLibraryModule {

}



// WEBPACK FOOTER //
// ./src/library/vertex-library/workflow-vertex-library.module.ts